import React, { useEffect, useState } from "react";
import styled from "styled-components";
import {
  getApiClient,
  makeStandardApiErrorHandler,
} from "../../../server/get_api_client";
import FileRow from "./FileRow";
import SideMenu from "../SideMenu";
import Nav from "../../Common/Nav";
import Footer from "../../Common/Footer";
import Information from "../../Common/Information";
import toast from "react-hot-toast";
import RequireLogin from "../../../permissions.js/RequireLogin";
import NothingToShow from "../../Common/NothingToShow";
import PageLoader from "../../Common/PageLoader";

function DocumentValut() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState();

  useEffect(() => {
    setIsLoading(true);
    getApiClient()
      .getFolders({ location: "" })
      .then((res) => {
        setData(res.data.children);
      })
      .catch(makeStandardApiErrorHandler((error) => toast.error(error)))
      .finally(() => setIsLoading(false));
  }, []);

  const mainBody = () => (
    <>
      {/* <p>
        Fill out your Digital Executor Form with person(s) you would like to
        have access to your information contained in your Active Document Vault
        in the event you become incapacitated or deceased and upload it to the
        Digital Executor form folder.
      </p> */}
      <ol>
        <li>
        When you want to send a document to Hippocratic, you can upload it into 'Upload to review by Hippocratic' and we will be notified.
        </li>
        <li>Securely store additional documents in their respective folders.</li>
        <li>
        If you feel you are missing documents please email support@hippocratic.com and our team will reach out shortly to assist you. 
        </li>
      </ol>
      <br />
      <p style={{ fontWeight: "bold" }}>
        Please be thorough as this information will be used to help us pre-fill
        your applications for you.
      </p>
    </>
  );

  const secondBody = () => (
    <>
      <p>
        <span style={{ fontWeight: "bold" }}>
          Uploading for Review by Hippocratic
        </span>
        ‐This is where you can upload anything you need us to review or look at.
        Also, you can put anything here that you aren't sure where it should be.
      </p>
      <ol>
        <li style={{ fontWeight: "bold" }}>
          Wills, Trusts, and Medical Directives
        </li>
        <ul>
          <li>Family Trust</li>
          <li>Medical Directives</li>
          <li>Other Trust</li>
          <li>Wills</li>
        </ul>
        <li style={{ fontWeight: "bold" }}>Debt</li>
        <ul>
          <li>Mortgage ‐ Loan Statements/Agreements</li>
          <li>Other</li>
          <li>Student Loans ‐ Student Loan Statements</li>
        </ul>
        <li style={{ fontWeight: "bold" }}>Investments</li>
        <ul>
          <li>
            2019 ‐ Retirement account statements (401k, All IRAs, UC DCP, 403b,
            457, LA County PSP)
          </li>
        </ul>
        <li style={{ fontWeight: "bold" }}>Taxes</li>
        <ul>
          <li>
            2017 ‐ Completed 1040's, 1120's, 1120S's and any other supporting
            documents
          </li>
          <li>
            2018 ‐ Completed 1040's, 1120's, 1120S's and any other supporting
            documents
          </li>
          <li>
            2019 ‐ Completed 1040's, 1120's, 1120S's and any other supporting
            documents
          </li>
        </ul>
        <li style={{ fontWeight: "bold" }}>Insurance</li>
        <ul>
          <li>
            Auto, Umbrella, Renters‐Homeowners ‐ Declaration pages and any
            security certificates for homes or vehicles
          </li>
          <li>
            Disability ‐ Declaration pages or any disability policies you
            currently have through work
          </li>
          <li>
            Health ‐ Health insurance policies and current coverage paperwork
          </li>
          <li>
            Life ‐ Life insurance policy declaration pages and current life
            insurance through work
          </li>
          <li>
            Long Term Care ‐ LTC Policy declarations and any policies you may
            own for relatives including children or parents
          </li>
          <li>Malpractice ‐ Copy of current Malpractice policy</li>
        </ul>
      </ol>
    </>
  );

  return (
    <>
      <PageLoader isLoading={isLoading} />
      <Nav />
      <Container>
        <TopSection>
          <NavigationInformation>
            Home &gt; My Profile &gt; Active Document Vault
          </NavigationInformation>
          <Title>Active Document Vault</Title>
        </TopSection>
        <BottomSection>
          <SideMenu />
          <RightContainer style={{ gap: "20px" }}>
            <Information header="Instructions" body={mainBody()} />
            <DigitalExecutorText>
              Designate your Document Vault access in the event of incapacity or death by completing and uploading the form in folder 7 Digital Executor Form.
            </DigitalExecutorText>
            
            {/* <Information
              header="Uploading for Review by Hippocratic"
              body={secondBody()}
            /> */}
            <FileContainer style={{ backgroundColor: "#e7f7fd" }}>
              <InnerContainer>
                {data ? (
                  data.map((data) => {
                    return <FileRow data={data} setIsLoading={setIsLoading} />;
                  })
                ) : (
                  <NothingToShow text={"No documents found"} />
                )}
              </InnerContainer>
            </FileContainer>
          </RightContainer>
        </BottomSection>
      </Container>
      <Footer />
    </>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 85vh;
  gap: 50px;
  padding: 0px 5vw;
`;

const FileContainer = styled.div`
  padding: 20px;
  width: 100%;
  height: 100%;
  border-radius: 5px;
`;

const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  min-height: 20vh;
  padding: 5px;
  background: linear-gradient(
    180deg,
    rgba(91, 197, 242, 0.5) 0%,
    rgba(91, 197, 242, 0) 100%
  );
`;

const TopSection = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 30px;
`;

const NavigationInformation = styled.div`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
`;

const Title = styled.div`
  color: var(--darkBlue);
  font-family: Georgia;
  font-size: 55px;
  font-style: normal;
  font-weight: 400;
  line-height: 90%;
  letter-spacing: -1.1px;

  @media screen and (max-width: 719px) {
    font-size: 40px;
  }
`;

const BottomSection = styled.div`
  display: flex;
  gap: 30px;
`;

const RightContainer = styled.div`
  display: flex;
  backgorund-color: #d4eef0;
  flex-direction: column;
  width: 100%;
  gap: 20px;
`;

const DigitalExecutorText = styled.p`
  color: var(--darkBlue);
  font-family: "Museo Sans Cyrl";
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  padding: 20px;
  background-color: #f8f9fa;
  border-left: 4px solid var(--darkBlue);
  border-radius: 4px;
  margin: 0;
`;

export default RequireLogin(DocumentValut);
